var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import CheckoutCard from "../../components/CheckoutCard/CheckoutCard";
import { CheckoutCardAsync } from "../../components/CheckoutCardAsync/CheckoutCardAsync";
import { CheckoutCardDynamic } from "../../components/CheckoutCardDynamic/CheckoutCardDynamic";
import { CheckoutCardSubscription } from "../../components/CheckoutCardSubscription/CheckoutCardSubscription";
import { CheckoutCardSubscriptionAsync } from "../../components/CheckoutCardSubscriptionAsync/CheckoutCardSubscriptionAsync";
import { CheckoutCardSubscriptionDynamic } from "../../components/CheckoutCardSubscriptionDynamic/ChekoutCardSubscriptionDynamic";
import { CheckoutCash } from "../../components/CheckoutCash/CheckoutCash";
import { CheckoutKpay } from "../../components/CheckoutKpay/Checkoutkpay";
import { CheckoutKpayEmptyPayment } from "../../components/CheckoutKpay/CheckoutKpayEmptyPayment/CheckoutKpayEmptyPayment";
import { CheckoutKpayPaymentSelect } from "../../components/CheckoutKpay/CheckoutKpayPaymentSelect/CheckoutKpayPaymentSelect";
import { KPayCvv } from "../../components/CheckoutKpay/KPayCvv/KPayCvv";
import { KpayEmail } from "../../components/CheckoutKpay/KpayEmail/KpayEmail";
import KpayOtpValidation from "../../components/CheckoutKpay/KpayOtpValidation/KpayOtpValidation";
import { CheckoutTransfer } from "../../components/CheckoutTransfer/CheckoutTransfer";
import { CheckoutTransferSubscription } from "../../components/CheckoutTransferSubscription/CheckoutTransferSubscription";
import ConfrontaAuth from "../../components/ConfrontaValidation/ConfrontaAuth/ConfrontaAuth";
import { ConfrontaQuestionSection } from "../../components/ConfrontaValidation/ConfrontaQuestionSection/ConfrontaQuestionSection";
import ConfrontaStart from "../../components/ConfrontaValidation/ConfrontaStart/ConfrontaStart";
import OtpInvalidTries from "../../components/OtpValidation/OtpInvalidTries/OtpInvalidTries";
import OtpValidation from "../../components/OtpValidation/OtpValidation";
import { PaymentMethods } from "../../components/PaymentMethods/PaymentMethods";
import { CountryEnum } from "./CountryEnum";
import { PaymentMethodsEnum } from "./PaymentMethodEnum";
import { PAYMENT_IMGS, PaymentMethodsImgEnum } from "./PaymentMethodImgEnum";
var configCardSections = {
    card: {
        body: {
            component: CheckoutCard,
        },
        header: {
            isSimpleHeader: false,
            title: "headerText.cardOrDebit",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    cardAsync: {
        body: {
            component: CheckoutCardAsync,
        },
        header: {
            isSimpleHeader: false,
            title: "itemTitles.cardAsync",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    cardDynamic: {
        body: {
            component: CheckoutCardDynamic,
        },
        header: {
            isSimpleHeader: false,
            title: "itemTitles.cardDynamic",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    cardSubscriptionAsync: {
        body: {
            component: CheckoutCardSubscriptionAsync,
        },
        header: {
            isSimpleHeader: false,
            title: "itemTitles.cardSubscriptionAsync",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    cardSubscriptionDynamic: {
        body: {
            component: CheckoutCardSubscriptionDynamic,
        },
        header: {
            isSimpleHeader: false,
            title: "itemTitles.cardSubscriptionDynamic",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    cash: {
        body: {
            component: CheckoutCash,
        },
        header: {
            isSimpleHeader: false,
            title: "itemTitles.cash",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CASH],
        },
    },
    confrontaAuth: {
        body: {
            component: ConfrontaAuth,
        },
        header: {
            isConfronta: true,
            isSimpleHeader: false,
            title: "itemTitles.checkData",
        },
    },
    confrontaQuestions: {
        body: {
            component: ConfrontaQuestionSection,
        },
        header: {
            isConfronta: true,
            isSimpleHeader: false,
            title: "itemTitles.checkData",
        },
    },
    confrontaStart: {
        body: {
            component: ConfrontaStart,
        },
        header: {
            isConfronta: true,
            isSimpleHeader: false,
            title: "itemTitles.checkData",
        },
    },
    kpay: {
        body: {
            component: CheckoutKpay,
        },
        header: {
            isSimpleHeader: true,
            logo: PAYMENT_IMGS[PaymentMethodsImgEnum.KPAY],
        },
    },
    kpayCvv: {
        body: {
            component: KPayCvv,
        },
        header: {
            isSimpleHeader: false,
            title: "headerText.cardOrDebit",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    kpayEmail: {
        body: {
            component: KpayEmail,
        },
        header: {
            isSimpleHeader: true,
            title: "kpayEmail.tittle",
        },
    },
    kpayEmptyPayment: {
        body: {
            component: CheckoutKpayEmptyPayment,
        },
        header: {
            isSimpleHeader: true,
            logo: PAYMENT_IMGS[PaymentMethodsImgEnum.KPAY],
        },
    },
    kpayOtp: {
        body: {
            component: KpayOtpValidation,
        },
        header: {
            isSimpleHeader: false,
            title: "headerText.cardOrDebit",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    kpayPaymentSelect: {
        body: {
            component: CheckoutKpayPaymentSelect,
        },
        header: {
            isSimpleHeader: true,
            logo: PAYMENT_IMGS[PaymentMethodsImgEnum.KPAY],
        },
    },
    kushkiOtp: {
        body: {
            component: OtpValidation,
        },
        header: {
            isSimpleHeader: false,
            title: "headerText.cardOrDebit",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    kushkiOtpInvalidTries: {
        body: {
            component: OtpInvalidTries,
        },
        header: {
            isSimpleHeader: false,
            title: "headerText.cardOrDebit",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    paymentMethods: {
        body: {
            component: PaymentMethods,
        },
        header: {
            isSimpleHeader: true,
            title: "headerText.paymentMethods",
        },
    },
    subscription: {
        body: {
            component: CheckoutCardSubscription,
        },
        header: {
            isSimpleHeader: false,
            title: "itemTitles.cardSubscription",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.CARD],
        },
    },
    transfer: {
        body: {
            component: CheckoutTransfer,
        },
        header: {
            isSimpleHeader: false,
            title: "itemTitles.transfer",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.TRANSFER],
        },
    },
    transferSubscription: {
        body: {
            component: CheckoutTransferSubscription,
        },
        header: {
            isConfronta: false,
            isSimpleHeader: false,
            title: "itemTitles.transferSubscription",
            titleImg: PAYMENT_IMGS[PaymentMethodsImgEnum.TRANSFER],
        },
    },
};
var CARD_SECTIONS_BY_COUNTRY = (_a = {},
    _a[CountryEnum.EC] = __assign(__assign({}, configCardSections), { subscription: __assign(__assign({}, configCardSections.subscription), { header: __assign(__assign({}, configCardSections.subscription.header), { title: "itemTitles.cardSubscriptionDynamic" }) }) }),
    _a[CountryEnum.CL] = __assign(__assign({}, configCardSections), { card: __assign(__assign({}, configCardSections.card), { header: __assign(__assign({}, configCardSections.card.header), { title: "itemTitles.creditCard" }) }) }),
    _a.default = configCardSections,
    _a);
var getCheckoutSection = function (country, paymentMethod, paymentMethods) {
    var _a;
    var cardSections = CARD_SECTIONS_BY_COUNTRY[country] || CARD_SECTIONS_BY_COUNTRY.default;
    var cardSectionByPaymentMethod = (_a = {},
        _a[PaymentMethodsEnum.CARD] = cardSections.card,
        _a[PaymentMethodsEnum.CASH] = cardSections.cash,
        _a[PaymentMethodsEnum.TRANSFER] = cardSections.transfer,
        _a[PaymentMethodsEnum.SUBSCRIPTION] = cardSections.subscription,
        _a[PaymentMethodsEnum.CARD_ASYNC] = cardSections.cardAsync,
        _a[PaymentMethodsEnum.CARD_DYNAMIC] = cardSections.cardDynamic,
        _a[PaymentMethodsEnum.CARD_SUBSCRIPTION_ASYNC] = cardSections.cardSubscriptionAsync,
        _a[PaymentMethodsEnum.CARD_SUBSCRIPTION_DYNAMIC] = cardSections.cardSubscriptionDynamic,
        _a[PaymentMethodsEnum.TRANSFER_SUBSCRIPTION] = cardSections.transferSubscription,
        _a.default = cardSections.paymentMethods,
        _a);
    var result = cardSectionByPaymentMethod[paymentMethod] ||
        cardSectionByPaymentMethod.default;
    result.header.hideChangePaymentMethod = paymentMethods.length === 1;
    return result;
};
export { configCardSections, getCheckoutSection };
